import { FlexContainer, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import { lottiesPaths } from 'Constants/lottiesPaths';
import { TaxScreenType } from 'Types/common';
import ResultInfo from '../ResultInfo';
import * as Styled from '../styles';

const DiscardedNotMandatory = ({ tax: { taxYear, filingInfo } }: TaxScreenType): JSX.Element => {
  const { t } = useTranslation(locizeNS.DASHBOARD);

  return (
    <FlexContainer justify="center" direction="column" align="center" gap="dimension_08">
      <Text size="L_L_S" color="dark" type="headline">
        {taxYear}
      </Text>
      <Text type="paragraphs" size="L_L_M" color="dark" align="center">
        {t(`Dashboard.discarded_not_mandatory.congratulations`)}
      </Text>
      <Text type="paragraphs" size="L_L_M" color="dark" align="center">
        {t(`Dashboard.discarded_not_mandatory.message`)}
      </Text>
      <Styled.StyledLottie
        options={{
          path: lottiesPaths.DISCARDED_NOT_MANDATORY,
          rendererSetting: { progressiveLoad: true },
        }}
      />
      {filingInfo && <ResultInfo filingInfo={filingInfo} />}
      <Text type="paragraphs" color="dark" size="M_L_S" align="center">
        {t(`Dashboard.discarded_not_mandatory.title`)}
      </Text>
      <Text type="paragraphs" color="dark" size="S_S_S" align="center">
        {t(`Dashboard.discarded_not_mandatory.description`)}
      </Text>
    </FlexContainer>
  );
};

export default DiscardedNotMandatory;
